import invariant from "invariant";

export function getLanguageFromLocale(locale) {
  return locale.substr(0, 2);
}

export function getDirectionFromLocale(locale) {
  return getLanguageFromLocale(locale) === "ar" ? "rtl" : "ltr";
}

export function getJSONValueFromField() {
  // return value;
  // try {
  //   const parsedValue = JSON.parse(value);
  //   return parsedValue;
  // } catch (e) {
  //   return value;
  // }
}

export function getURLFromField(fieldValue) {
  const url = (fieldValue && fieldValue.url) || fieldValue;
  // const value = getJSONValueFromField(fieldValue);
  return url;
}

export function invariantElementsContext({ Elements } = {}) {
  invariant(
    Elements,
    "[Wuilt Section Elements] Could not find required `Elements` object. " +
      "<SectionElementsProvider> needs to exist in the component ancestry."
  );
}
